module.exports = __webpack_public_path__ + "static/media/Group 95712.cde71e75.svg";